'use client';

import Label from '@/components/typography/label';
import Quote from '@/components/typography/quote';
import { TextReveal } from '@/components/ui/text-reveal';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <>
            <div className="relative mt-20 flex min-h-[calc(100svh+160px)] flex-col items-center justify-center border-b border-black px-[1.27rem] sm:mt-0 lg:min-h-[calc(100svh+247px)] lg:justify-start lg:px-12 lg:pt-[19rem]">
                <h1 className="visually-hidden">${t('hero.h1')}</h1>
                <div className="mb-[4rem] max-w-[350px] sm:max-w-[400px] md:max-w-[650px] lg:mb-[14rem] lg:max-w-[850px] xl:max-w-[1100px] 2xl:max-w-[1550px]">
                    <Label className="mr-[5rem] ml-2 inline align-text-top lg:mr-[15.5rem] lg:align-super">
                        {t('hero.about')}
                    </Label>
                    <Quote className="inline">
                        <TextReveal start={0.1} end={0.9}>
                            {t('hero.text')}
                        </TextReveal>
                    </Quote>
                </div>
                <CoffeeImage />
            </div>
        </>
    );
}

export function CoffeeImage({ className }: { className?: string }) {
    return (
        <figure
            className={cn(
                'absolute right-0 bottom-[-8.5rem] z-10 aspect-square h-[250px] w-auto max-w-full overflow-hidden lg:bottom-[-17.5rem] lg:h-[530px]',
                className,
            )}
        >
            <Image
                src="/images/about/coffe.png"
                alt="About Us"
                width={1600}
                height={1600}
                className="translate-x-[4.5rem] object-contain"
            />
        </figure>
    );
}
